/**
 * Where the contributor-network API lives.
 *
 * In dev, leave VITE_API_URL unset: Vite proxies /api to the staging API
 * (see vite.config.ts), so the browser stays on one origin. Production
 * builds also leave it unset and nginx proxies /api to the production API.
 */
const DEFAULT_BASE = "/api/v1";

export const API_BASE: string = (
  import.meta.env.VITE_API_URL || DEFAULT_BASE
).replace(/\/$/, "");

export function apiUrl(path: string): string {
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}
